import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';

export interface CookingSessionStatus {
    completedRecipes: Set<string>;
    completedSteps: Set<string>;
    struckIngredients: Set<string>;
    preppedIngredients: Set<string>;
    mealCompleted: boolean;
}

function parseStringSet(value: unknown): Set<string> {
    return new Set(
        Array.isArray(value)
            ? value.filter((entry): entry is string => typeof entry === 'string')
            : []
    );
}

function parseSessionStatus(data: Record<string, unknown>): CookingSessionStatus {
    return {
        completedRecipes: parseStringSet(data.completedRecipes),
        completedSteps: parseStringSet(data.completedSteps),
        struckIngredients: parseStringSet(data.struckIngredients),
        preppedIngredients: parseStringSet(data.preppedIngredients),
        mealCompleted: Boolean(data.mealCompleted),
    };
}

export function useCookingSessionStatuses(activeHouseholdId?: string): Map<string, CookingSessionStatus> {
    const [statuses, setStatuses] = useState<Map<string, CookingSessionStatus>>(() => new Map());

    useEffect(() => {
        if (!activeHouseholdId) {
            setStatuses(new Map());
            return;
        }

        const sessionsRef = collection(db, 'households', activeHouseholdId, 'cookingSessions');
        return onSnapshot(sessionsRef, (snapshot) => {
            const next = new Map<string, CookingSessionStatus>();
            snapshot.docs.forEach((docSnap) => {
                next.set(docSnap.id, parseSessionStatus(docSnap.data()));
            });
            setStatuses(next);
        }, (error) => {
            console.error('Cooking session statuses listener error:', error);
        });
    }, [activeHouseholdId]);

    return statuses;
}
